import { VehicleDefinitionItem } from '@/lib/types/vehicle/vehicle'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface VehiclesState {
  definitions: VehicleDefinitionItem[]
  loading: boolean
  error: string | null
}

const initialState: VehiclesState = {
  definitions: [],
  loading: false,
  error: null,
}

const vehiclesSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    setVehicleDefinitions: (state, action: PayloadAction<VehicleDefinitionItem[]>) => {
      state.definitions = action.payload
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const {
  setVehicleDefinitions,
  setLoading,
  setError,
} = vehiclesSlice.actions

export default vehiclesSlice.reducer
